export class Perimeter {
  url: string;
  name: string;
  logo?: string;

  constructor(perimeter?: Perimeter) {
    this.url = perimeter?.url ?? null;
    this.name = perimeter?.name ?? null;
    this.logo = perimeter?.logo ?? null;
  }
}
